import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import KinerjaBerandaIndex from 'app/KinerjaBerandaPage/pages/Index'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'
import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    _toggle: TToggleKeyValuePair
  ) => {
    const currentTime = new Date().getTime()
    const showBanner = currentTime < new Date('2024-04-10 00:00:00').getTime() // Banner will be shown until before 10 April 2024 00:00:00 GMT+7

    return {
      props: {
        showBanner,
      },
    }
  },
})

const Page = (props: PageProps & { showBanner: boolean }) => (
  <KinerjaBerandaIndex {...props} />
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
}

export default Page
